
import React, { Component } from 'react';
import { CustomInput, Label, Input, FormGroup, FormFeedback, Form } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import EirRecaptcha from '../eir-recaptcha/EirRecaptcha';
var loadTooltip;
var loadCalendar;
var loadCalendarNoRestriction;

export class EirOnlineFormBuilder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sending: false,
            response: null,
            landlineAreaCode: [],
            mobileAreaCode: [],
            countyList: [],
            fileDetails: false,
            errMessage: '',
            proxyprops : (this.props.isFromListPage) ? this.props.isFromListPage : this.props,
            sectionTitleColor: (this.props.sectionTitleColor != undefined) ? this.props.sectionTitleColor : '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    closeButton=()=>{
        // console.log("test tset icon");
        var  tempElement=document.createElement('div');
                tempElement.className="tooltip__interactive__close js-tooltip-close";
                // document.getElementsByTagName('head')[0].appendChild(tempElement);
        document.getElementsByClassName('tooltipster-base')[0].appendChild(tempElement);

    }
    componentWillMount = () => {
        
        this.setState({
            response : null,
            sending:false

        })
        fetch('/json/counties.txt')
            .then(res => res.json())
            .then(data => this.setState({ countyList: data }));

        fetch('/json/areacodes_mobile.txt')
            .then(res => res.json())
            .then(data => this.setState({ mobileAreaCode: data }));

        fetch('/json/areacodes.txt')
            .then(result => result.json())
            .then(data => this.setState({ landlineAreaCode: data }));
    }

componentWillUnmount=()=>
{
    var tempElement=document.querySelector('#dynamicStyle');
    document.getElementsByTagName('head')[0].removeChild(tempElement);
}
    componentDidMount = () => {
        
        var tempElement=document.createElement('style');
        tempElement.id="dynamicStyle";
        document.getElementsByTagName('head')[0].appendChild(tempElement);
        document.querySelector('#dynamicStyle').innerText=".custom-control-input:checked ~ .custom-control-label::before{background-color:"+this.state.proxyprops.sectionTitleColor+"!important;} .form-builder .form-control:focus {border-color: "+this.state.proxyprops.sectionTitleColor+";}"
        // console.log("from FormBuilder DidMount >>>>>>>>>>>>>>>>>");
        document.querySelector(".form-builder").focusFirstElement = this.focusFirstElement;
    }
    
     

    async handleSubmit(event) {
        
        if (this.state.proxyprops.EmailFromAddressOverride == "") {
       
            // $("#EMAIL_FROM_ADDRESS_OVERRIDE").val("noreply@eir.ie");
            document.querySelector('#EMAIL_FROM_ADDRESS_OVERRIDE').value = "noreply@eir.ie";
        }
        else {
            // var emailOverride = $("#" + this.state.proxyprops.EmailFromAddressOverride).val();
            var emailOverride = document.querySelector("#" + this.state.proxyprops.EmailFromAddressOverride).value;
            // $("#EMAIL_FROM_ADDRESS_OVERRIDE").val(emailOverride);

            document.querySelector('#EMAIL_FROM_ADDRESS_OVERRIDE').value = emailOverride;
        }
        let form = event.target;
        event.preventDefault();
        event.stopPropagation();

        form = document.querySelectorAll('form')[0];
        if (this.state.fileDetails == true) {

            return false;
        }
        if (form.checkValidity() != false) {
            this.setState({
                sending: true
            });

            let response = await fetch(this.state.proxyprops.formAction,
                {
                    method: form.method,
                    body: new FormData(document.querySelectorAll('form')[0])
                }
            );

            this.setState({
                response: await response.json(),
                sending: false
            });
            if (this.state.response.result.status == 'failure' && this.state.response.result.details.uploadError != null) {
                switch (this.state.response.result.details.uploadError.code) {
                    case "FILETYPE_NOT_ACCEPTED":
                        this.setState({
                            errMessage: "Please upload a valid file.",

                        })
                        break;

                    case "LIMIT_FILE_SIZE":
                        this.setState({
                            errMessage: "This files size exceeds the limit.",

                        })
                        break;


                    default:
                        this.setState({
                            errMessage: " Form Submission Failed",

                        })
                }
            }
            if (this.state.response.result.status == 'failure' && this.state.response.result.details.uploadError == null) {
                this.setState({
                    errMessage: " Form Submission Failed",

                })
            }

            if ((this.state.response != null && this.state.response.result.status == 'success') || (this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false))) {
                let scrollStep = -window.pageYOffset / (1000 / 15);
                let scrollInterval = setInterval(function () {
                    if (window.pageYOffset != 0) {
                        window.scrollBy(0, scrollStep);

                    } else clearInterval(scrollInterval);
                }, 15);
                
            }
        }
        form.classList.add('was-validated');

        if ($(".was-validated .form-control:invalid")[0] != undefined) {
            $(".was-validated .form-control:invalid")[0].focus();
        }
    }
    renderContent = (content) => {

        return { __html: content };

    }
    hiddenSection = (e) => {
        var className = e.target.id;
        var classNameArray = className.split(" ");

        var className = classNameArray[1];
        var elems = document.querySelectorAll("." + className);

        if (classNameArray.length > 2 && classNameArray != undefined) {
            for (var i = 2; i < classNameArray.length; i++) {
                var elemsId = document.querySelector("#" + classNameArray[i]);

                var inputField = document.querySelectorAll("#" + classNameArray[i] + " " + 'input');
                elemsId.style.display = 'none';
                elemsId.disabled = true;

                if (inputField.length > 0 && inputField != undefined) {
                    for (var j = 0; j < inputField.length; j++) {
                        if (inputField[j].getAttribute("type") != "file" && inputField[j].getAttribute("type") != "hidden") {
                            inputField[j].value = "";
                        }
                    }
                }
                var selectField = document.querySelectorAll("#" + classNameArray[i] + " " + 'select');


                if (selectField.length > 0 && selectField != undefined) {
                    for (var k = 0; k < selectField.length; k++) {
                        selectField[k].selectedIndex = 0;
                    }
                }
                var CheckboxField = document.querySelectorAll("#" + classNameArray[i] + " " + "[type='checkbox']");


                if (CheckboxField.length > 0 && CheckboxField != undefined) {
                    for (var l = 0; l < CheckboxField.length; l++) {
                        CheckboxField[l].checked = false;
                    }
                }

            }

        }

        // className = classNameArray[(classNameArray.length) - 1];
        var elems = document.querySelectorAll("." + className);
        var inputFields = document.querySelectorAll("." + className + ' ' + 'input');




        if (inputFields.length > 0 && inputFields != undefined) {
            for (var m = 0; m < inputFields.length; m++) {
                if (inputFields[m].getAttribute("type") != "file" && inputFields[m].getAttribute("type") != "hidden") {
                    inputFields[m].value = "";
                }
            }
        }
        var selectField = document.querySelectorAll("." + className + " " + 'select');


        if (selectField.length > 0 && selectField != undefined) {
            for (var n = 0; n < selectField.length; n++) {
                selectField[n].selectedIndex = 0;
            }
        }
        var CheckboxField = document.querySelectorAll("." + className + " " + "[type='checkbox']");


        if (CheckboxField.length > 0 && CheckboxField != undefined) {
            for (var p = 0; p < CheckboxField.length; p++) {
                CheckboxField[p].checked = false;
            }
        }


        var elems = document.querySelectorAll("." + className);
        for (var o = 0; o < elems.length; o++) {
            elems[o].style.display = 'none';
            elems[o].disabled = true;


        }
        var hiddenFieldValue = e.target.value;

        hiddenFieldValue = hiddenFieldValue.split(' ').join('_');

        document.querySelector('#' + hiddenFieldValue).disabled = false;
        document.querySelector('#' + hiddenFieldValue).style.display = 'block';

    }

    hiddenCheckCondition = (e) => {
        var id = e.target.id;
        var classNameArray = id.split(" ");

        var className = classNameArray[(classNameArray.length) - 1];

        if (document.getElementById(id).checked) {

            document.querySelector('.' + className).style.display = 'block';
            document.querySelector('.' + className).disabled = false;
        }
        else {

            document.querySelector('.' + className).style.display = 'none';
            document.querySelector('.' + className).disabled = true;
        }

    }

          componentDidUpdate(prevProps) {
            //the below condtion is only when the component is called from Form list page 
            if (this.props.isFromListPage && (this.props.isFromListPage.formName !== prevProps.isFromListPage.formName)) {
                
                // $('body').on('focus',".form-date-picker", function(){
                //     var mind = eirDatePicker.getMinDate(3);
                    
                //     if ($(this).hasClass('js-date-picker-no-restriction')) {
                       
                //         $(this).datepicker({ dateFormat: 'dd/mm/yy' });
                //     }
                //     else {
                //         $(this).datepicker({ minDate: mind, maxDate: '+28D', numberOfMonths: 1, beforeShowDay: eirDatePicker.noWeekendsOrHolidays, dateFormat: 'dd/mm/yy' });

                //     }
                // });
                this.setState({
                    response: null, //when user clicks on different form after submitting a form - load and render the form
                    sending: false, //when user clicks on different form after submitting a form - load and render the form
                    proxyprops : this.props.isFromListPage
                })
                
            }
            
            if(document.getElementsByTagName("form")[0] != undefined) document.getElementsByTagName("form")[0].reset();
                var mind = eirDatePicker.getMinDate(5);  
                this.loadCalendarNoRestriction =  $(".form-date-picker.js-date-picker-no-restriction").datepicker({ dateFormat: 'dd/mm/yy' });            
                this.loadCalendar = $(".form-date-picker").datepicker({ minDate: mind, maxDate: '+28D', numberOfMonths: 1, beforeShowDay: eirDatePicker.noWeekendsOrHolidays, dateFormat: 'dd/mm/yy' });
                this.loadTooltip = tooltips.init();
          }

          focusFirstElement = () => {
            const form = document.querySelector(".form-builder");
            if (!form) return;
            const firstFocusable = form.querySelector(`
              a[href],
              button,
              input:not([type="hidden"]),
              select,
              textarea,
              [tabindex]:not([tabindex="-1"])
            `);
          
            if (firstFocusable) {
                let formDisabled = false;
                //Initially remove negative tabindexes
                const all1 = form.querySelectorAll("[tabindex='-1']");
                all1.forEach(el => el.removeAttribute("tabindex"));

                document.querySelectorAll("iframe[src*='recaptcha']").forEach(i => i.removeAttribute("tabindex"));
                
                // requestAnimationFrame(() => {
                //     firstFocusable.style.outline = "3px solid #dd1d78";
                // });

                formDisabled = false;
                firstFocusable.focus();

                const disableFormTabbingOnce = () => {
                    const allFocusables = form.querySelectorAll(`
                    a[href],
                    button,
                    input:not([type="hidden"]),
                    select,
                    textarea,
                    [tabindex]:not([tabindex="-1"])
                    `);

                    allFocusables.forEach(el => el.setAttribute("tabindex", "-1"));
                    document.querySelectorAll("iframe[src*='recaptcha']").forEach(i => i.setAttribute("tabindex", "-1"));
                    formDisabled = true;
                };
              
                const enableFormTabbing = () => {
                    const all = form.querySelectorAll("[tabindex='-1']");
                    all.forEach(el => el.removeAttribute("tabindex"));                    
                    // requestAnimationFrame(() => {
                    //     firstFocusable.style.outline = "3px solid #dd1d78";
                    // });
                    formDisabled = false;
                };
               
                const handleShiftTab = (e) => {
                    if (e.key === "Tab" && e.shiftKey && document.activeElement === firstFocusable) {
                        e.preventDefault(); 
                        disableFormTabbingOnce();     
                        firstFocusable.style.outline="none";          
                        const activeMenu = document.querySelector(".selected-form-item .leftmenu-list-item").closest(".selected-form-item");
                        if (activeMenu) activeMenu.focus();
                        firstFocusable.removeEventListener("keydown", handleShiftTab);
                    }
                };
                firstFocusable.addEventListener("keydown", handleShiftTab);
              
                const activeMenuItem = document.querySelector(".selected-form-item .leftmenu-list-item").closest(".selected-form-item");
                if (activeMenuItem) {
                    activeMenuItem.addEventListener("keydown", (e) => {
                    if (
                        e.key === "Enter" ||
                        e.key === " " ||
                        e.key === "Spacebar"
                    ) {
                        enableFormTabbing();
                        setTimeout(() => firstFocusable.focus(), 0);
                    }
                    });
                }
            }
        };

    openTooltipOnFocus = (e) => {        
        e.currentTarget.dispatchEvent(
            new MouseEvent("mouseover", { bubbles: true })
          );
    };
  
    closeTooltipOnBlur = (e) => {        
        e.currentTarget.dispatchEvent(
            new MouseEvent("mouseout", { bubbles: true })
          );
    }

    render() {
        this.loadTooltip;
        this.loadCalendar;
        this.loadCalendarNoRestriction;
        const landlineAreaCode = this.state.landlineAreaCode.areacodes;
        const mobileAreaCode = this.state.mobileAreaCode.areacodes;
        const CList = this.state.countyList.counties;
        // console.log(this.props);
        // console.log("from FormBuilder render >>>>>>>>>>>>>>>>>");

        // console.log("EirOnlineFormBuilder ---------- from child -----------  from render this.state.proxyprops >>>>>>>>>> ", this.state.proxyprops)
        // console.log("mobile", mobileAreaCode)
        // console.log("landline", landlineAreaCode)
        // this.state.proxyprops  =  (this.props.isFromListPage) ? this.props.isFromListPage : this.props
        // console.log(this.props)
        let formReference = document.getElementsByTagName("form")[0];

        if(formReference != undefined) {

            formReference.classList.contains("was-validated") ? formReference.classList.remove("was-validated") : ''

        }
        
        return (

            <div className="form-builder">

                <div className="mb-5 mt-1 container d-flex flex-column justify-content-center form-holder">
                    <h2 className="eir-title display-4 eir-display-xl-3"  style={{color: "black"}}>{this.state.proxyprops.formName}</h2>
                    {this.state.proxyprops.EirParagraphs != undefined && this.state.proxyprops.EirParagraphs.map((EirParagraph, index) => {
                        return (
                            <p key={index} dangerouslySetInnerHTML={this.renderContent(EirParagraph.paragraph)}></p>
                        );
                    })}



                    {(this.state.response == null && !this.state.sending) && (
                        <Form method="post" action={this.state.proxyprops.formAction} noValidate={false} className="needs-validation" onSubmit={this.handleSubmit} >
                            <Input type="hidden" value={this.state.proxyprops.email} id="Email_To_Address" name="Email_To_Address" aria-label="Email_To_Address"/>
                            <Input type="hidden" value={this.state.proxyprops.formName} id="Email_Subject" name="Email_Subject" aria-label="Email_Subject"/>
                            <Input type="hidden" value={this.state.proxyprops.formName} id="Form_Name" name="Form_Name" aria-label="Form_Name"/>
                            <Input type="hidden" id="EMAIL_FROM_ADDRESS_OVERRIDE" name="EMAIL_FROM_ADDRESS_OVERRIDE" aria-label="EMAIL_FROM_ADDRESS_OVERRIDE" />
                            <div className="customer-identity-container">
                                {this.state.proxyprops.formBuilderSections.map((formBuilderSection, index) => {
                                    return (
                                        <fieldset key={index} className={(formBuilderSection.sectionType == "hiddenSection") ? formBuilderSection.sectionClassName : ""} id={(formBuilderSection.sectionType == "hiddenSection") ? formBuilderSection.sectionId : ""} style={(formBuilderSection.sectionType == "hiddenSection") ? { display: 'none' } : { display: 'block',borderTop:'2px solid #d7d7d7',paddingTop: '20px' }} disabled={(formBuilderSection.sectionType == "hiddenSection") ? true : false}>
                                            <Input type="hidden" value={formBuilderSection.sectionTitle} id={formBuilderSection.sectionId + "_Sub_Heading"} name={formBuilderSection.sectionId + "_Sub_Heading"} />

                                            <h3 style={{color: this.state.proxyprops.sectionTitleColor}}>
                                                {formBuilderSection.sectionTitle}
                                            </h3>

                                            {formBuilderSection.formBuilderSectionoptions != undefined &&
                                                formBuilderSection.formBuilderSectionoptions.map((formBuilderSectionoptions, index) => {
                                                    return (

                                                        <React.Fragment key={index}>

                                                            {formBuilderSectionoptions.formBuilderInputs != undefined && formBuilderSectionoptions.formBuilderInputs.map((formBuilderInputs, index) => {

                                                                if (formBuilderInputs.pattern == "none") {

                                                                    delete formBuilderInputs.pattern;
                                                                }


                                                                if (formBuilderInputs.pattern == "onlyDigits") {
                                                                    formBuilderInputs.pattern = "^[0-9-+s()]*$";

                                                                }
                                                                if (formBuilderInputs.pattern == "alphaNumeric") {
                                                                    formBuilderInputs.pattern = "^[0-9a-zA-Z \\.\\s]*$";

                                                                }
                                                                if (formBuilderInputs.pattern == "alphaSpecialCharacters") {
                                                                    formBuilderInputs.pattern = "[a-zA-Z'’\\s]+";

                                                                }

                                                                return (
                                                                    <React.Fragment key={formBuilderInputs.inputId}>
                                                                        {formBuilderInputs.FormBuilderInputFields.map((FormBuilderInputFields, index) => {
                                                                            switch (FormBuilderInputFields.inputType) {
                                                                                case "countyList":
                                                                                    return (
                                                                                        <FormGroup key={formBuilderInputs.inputId} className="row">
                                                                                            <div className="col-sm-4">
                                                                                            <Label>{formBuilderInputs.label}<span className="mandatory">*</span></Label>
                                                                                            </div>
                                                                                            <div className="col-sm-8 form-element--info">
                                                                                            <Input name={formBuilderInputs.inputId} type="select" aria-label={formBuilderInputs.label} id={formBuilderInputs.inputId}

                                                                                                required={formBuilderInputs.Required}>
                                                                                                <option value="">Select County</option>
                                                                                                {CList != undefined &&
                                                                                                    (CList.map((name, i) => <option key={name.name}>{name.name}</option>))
                                                                                                }
                                                                                            </Input>
                                                                                            {(formBuilderInputs.infoIcon == "yes")&& <div className="form-element--info__icon" tabIndex="0" role="button" onFocus={this.openTooltipOnFocus} onBlur={this.closeTooltipOnBlur} onClick={this.closeButton} aria-label={formBuilderInputs.infoText.replace(/<[^>]*>?/gm, '')} data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"></div>}

                                                                                            <FormFeedback>{formBuilderInputs.errorMsg} </FormFeedback>
                                                                                            </div>
                                                                                        </FormGroup>
                                                                                    );
                                                                                    break;
                                                                                case "Select":
                                                                                    switch (FormBuilderInputFields.inputTypeName) {
                                                                                        case "HiddenDropdown":

                                                                                            return (
                                                                                                <FormGroup key={formBuilderInputs.inputId} className="row">
                                                                                                <div className="col-sm-4">
                                                                                                    <Label>{formBuilderInputs.label}<span className="mandatory">*</span></Label>
                                                                                                    </div>
                                                                                                    <div className="col-sm-8 form-element--info">
                                                                                                    <Input name={formBuilderInputs.inputId} type="select" aria-label={formBuilderInputs.label} id={formBuilderInputs.inputId + " " + formBuilderInputs.inputClassName}

                                                                                                        required={formBuilderInputs.Required} onChange={this.hiddenSection}>
                                                                                                        <option value="">Please select one of the options below</option>
                                                                                                        {(FormBuilderInputFields.option.map((optionValue, i) => <option key={optionValue}>

                                                                                                            {optionValue}</option>))}
                                                                                                    </Input>
                                                                                                    {(formBuilderInputs.infoIcon == "yes")&& <div className="form-element--info__icon" tabIndex="0" role="button" onClick={this.closeButton} onFocus={this.openTooltipOnFocus} onBlur={this.closeTooltipOnBlur} aria-label={formBuilderInputs.infoText.replace(/<[^>]*>?/gm, '')} data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"></div>}

                                                                                                    <FormFeedback>{formBuilderInputs.errorMsg} </FormFeedback>
                                                                                                    </div>
                                                                                                </FormGroup>
                                                                                            );
                                                                                        default:
                                                                                            return (
                                                                                                <FormGroup key={formBuilderInputs.inputId} className="row">
                                                                                                <div className="col-sm-4">
                                                                                                    <Label>{formBuilderInputs.label}<span className="mandatory">*</span></Label>
                                                                                                    </div>
                                                                                                    <div className="col-sm-8 form-element--info">
                                                                                                    <Input name={formBuilderInputs.inputId} type="select" aria-label={formBuilderInputs.label} id={formBuilderInputs.inputId}

                                                                                                        required={formBuilderInputs.Required}>
                                                                                                        <option value="">Please select one of the options below</option>
                                                                                                        {(FormBuilderInputFields.option.map((optionValue, i) => <option key=

                                                                                                            {optionValue}>{optionValue}</option>))}
                                                                                                    </Input>
                                                                                                    {(formBuilderInputs.infoIcon == "yes")&& <div className="form-element--info__icon" tabIndex="0" role="button" onClick={this.closeButton} onFocus={this.openTooltipOnFocus} onBlur={this.closeTooltipOnBlur} aria-label={formBuilderInputs.infoText.replace(/<[^>]*>?/gm, '')} data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"></div>}

                                                                                                    <FormFeedback>{formBuilderInputs.errorMsg} </FormFeedback>
                                                                                                    </div>
                                                                                                </FormGroup>
                                                                                            );
                                                                                    }
                                                                                case "checkbox":
                                                                                    switch (FormBuilderInputFields.inputTypeName) {
                                                                                        case "hiddenCheckbox":
                                                                                            return (
                                                                                                <FormGroup key={formBuilderInputs.inputId} >
                                                                                                    <div >

                                                                                                        <div className="form-group">
                                                                                                            <div>
                                                                                                                <div className="custom-checkbox custom-control">
                                                                                                                    <Input required={formBuilderInputs.Required} name={formBuilderInputs.inputId} aria-invalid="false" type="checkbox" id={formBuilderInputs.inputId + " " + formBuilderInputs.inputClassName} className="custom-control-input" style={{opacity:1, marginLeft:'-1.35rem'}} value="true" onClick={this.hiddenCheckCondition} onKeyDown={(e) => {if (e.key === "Enter") { e.preventDefault(); e.target.click();}}} />
                                                                                                                    <label className="custom-control-label" htmlFor={formBuilderInputs.inputId + " " + formBuilderInputs.inputClassName} dangerouslySetInnerHTML={this.renderContent(formBuilderInputs.label)}></label>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </FormGroup>

                                                                                            );
                                                                                        default:
                                                                                            return (
                                                                                                <FormGroup key={formBuilderInputs.inputId} >
                                                                                                    <div >

                                                                                                        <div className="form-group">
                                                                                                            <div>
                                                                                                                <div className="custom-checkbox custom-control">
                                                                                                                    <Input required={formBuilderInputs.Required} name={formBuilderInputs.inputId} aria-invalid="false" type="checkbox" id={formBuilderInputs.inputId} className="custom-control-input" style={{opacity:1, marginLeft:'-1.35rem'}} value="true" onKeyDown={(e) => {if (e.key === "Enter") { e.preventDefault(); e.target.click();}}}/>
                                                                                                                    <label className="custom-control-label" htmlFor={formBuilderInputs.inputId} dangerouslySetInnerHTML={this.renderContent(formBuilderInputs.label)}></label>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </FormGroup>
                                                                                            );
                                                                                    }
                                                                                    break;
                                                                                case "radio":

                                                                                    return (

                                                                                        <FormGroup check inline key={formBuilderInputs.inputId} >

                                                                                            <Label check>
                                                                                                <Input type="radio" value={formBuilderInputs.label} name={formBuilderInputs.inputId} onClick={this.closeAccount} required={formBuilderInputs.Required} />{' '}
                                                                                                {formBuilderInputs.label}
                                                                                                <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                            </Label>

                                                                                        </FormGroup>


                                                                                    );

                                                                                case "tel":
                                                                                    switch (FormBuilderInputFields.prefix) {
                                                                                        case "mobileprefix":
                                                                                            return (
                                                                                                <div className="form-group row" key={formBuilderInputs.inputId}>
                                                                                                <div className="col-sm-4">
                                                                                                    <Label>{formBuilderInputs.label} {formBuilderInputs.Required && <span className="mandatory">*</span>}</Label><br />
                                                                                                    </div>
                                                                                                    <div className="col-sm-8 form-element--info">
                                                                                                    <FormGroup check inline className="prefix" key={index}>

                                                                                                        <Input name={"Mobile_Prefix_of_" + formBuilderInputs.inputId} type="select" aria-label={"Mobile_Prefix_of_" + formBuilderInputs.inputId} id={"Mobile_Prefix_of_" + formBuilderInputs.inputId} required={formBuilderInputs.Required}>
                                                                                                            <option value="">08X</option>
                                                                                                            {mobileAreaCode != undefined && (mobileAreaCode.map((optionValue, i) => <option key={optionValue.code}>{optionValue.code}</option>))}
                                                                                                        </Input>
                                                                                                    </FormGroup>
                                                                                                    <FormGroup check inline className="prefix field-align" key={formBuilderInputs.inputId} >

                                                                                                        <Input name={formBuilderInputs.inputId}  aria-label={formBuilderInputs.label} type={FormBuilderInputFields.inputType} placeholder={formBuilderInputs.placeholder} minLength="6" maxLength="10" title={formBuilderInputs.labels} pattern={formBuilderInputs.pattern} id={formBuilderInputs.inputId} required=

                                                                                                            {formBuilderInputs.Required} />
                                                                                            {(formBuilderInputs.infoIcon == "yes")&& <div className="form-element--info__icon" tabIndex="0" role="button" onFocus={this.openTooltipOnFocus} onBlur={this.closeTooltipOnBlur} onClick={this.closeButton} aria-label={formBuilderInputs.infoText.replace(/<[^>]*>?/gm, '')} data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"></div>}

                                                                                                        <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                                           
                                                                                                    </FormGroup>
                                                                                                    </div>  
                                                                                                </div>);
                                                                                        case "landlineprefix":

                                                                                            return (<div className="form-group row" key={formBuilderInputs.inputId}>
                                                                                            <div className="col-sm-4">
                                                                                                <Label>{formBuilderInputs.label} {formBuilderInputs.Required && <span className="mandatory">*</span>}</Label><br />
                                                                                                </div>
                                                                                                    <div className="col-sm-8 form-element--info">

                                                                                                
                                                                                                <FormGroup check inline className="prefix" key={index}>


                                                                                                    <Input name={"Landline_Prefix_of_" + formBuilderInputs.inputId} type="select" aria-label={"Landline_Prefix_of_" + formBuilderInputs.inputId} id={"Landline_Prefix_of_" + formBuilderInputs.inputId} required={formBuilderInputs.Required}>
                                                                                                        <option value="">0XX</option>
                                                                                                        {landlineAreaCode != undefined && (landlineAreaCode.map((optionValue, i) => <option key={optionValue.code}>{optionValue.code}</option>))}
                                                                                                    </Input>
                                                                                                </FormGroup>
                                                                                                <FormGroup check inline key={formBuilderInputs.inputId} className="prefix field-align">

                                                                                                    <Input name={formBuilderInputs.inputId} aria-label={formBuilderInputs.label} type={FormBuilderInputFields.inputType} placeholder={formBuilderInputs.placeholder} minLength="5" maxLength="10" title={formBuilderInputs.labels} pattern={formBuilderInputs.pattern} id={formBuilderInputs.inputId} required=

                                                                                                        {formBuilderInputs.Required} />
                                                                                            {(formBuilderInputs.infoIcon == "yes")&& <div className="form-element--info__icon" tabIndex="0" role="button" onClick={this.closeButton} onFocus={this.openTooltipOnFocus} onBlur={this.closeTooltipOnBlur} aria-label={formBuilderInputs.infoText.replace(/<[^>]*>?/gm, '')} data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"></div>}

                                                                                                    <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>

                                                                                                </FormGroup>
                                                                                                </div>
                                                                                            </div>);
                                                                                        default:
                                                                                            return (<FormGroup key={formBuilderInputs.inputId}  className="row">
                                                                                            <div className="col-sm-4">
                                                                                                <Label>{formBuilderInputs.label} {formBuilderInputs.Required && <span className="mandatory">*</span>}</Label>
                                                                                                </div>
                                                                                                <div className="col-sm-8 form-element--info">
                                                                                                <Input name={formBuilderInputs.inputId} aria-label={formBuilderInputs.label} type={FormBuilderInputFields.inputType} placeholder={formBuilderInputs.placeholder} minLength="6" maxLength="10" title={formBuilderInputs.labels} pattern={formBuilderInputs.pattern} id={formBuilderInputs.inputId} required=

                                                                                                    {formBuilderInputs.Required} />
                                                                                 {(formBuilderInputs.infoIcon == "yes")&& <div className="form-element--info__icon" tabIndex="0" role="button" onClick={this.closeButton} onFocus={this.openTooltipOnFocus} onBlur={this.closeTooltipOnBlur} aria-label={formBuilderInputs.infoText.replace(/<[^>]*>?/gm, '')} data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"></div>}

                                                                                                <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                                </div>
                                                                                            </FormGroup>);

                                                                                    }

                                                                                case "number":
                                                                                    return (
                                                                                        <FormGroup key={formBuilderInputs.inputId} className="row">
                                                                                        <div className="col-sm-4">
                                                                                            <Label>{formBuilderInputs.label} {formBuilderInputs.Required && <span className="mandatory">*</span>}</Label>
                                                                                            </div>
                                                                                            <div className="col-sm-8 form-element--info">

                                                                                            <div className="amount_prefix">
                                                                                                <Input name={formBuilderInputs.inputId} aria-label={formBuilderInputs.label} type="text" step="0.000001" style={{ paddingLeft: 25 }} min="0" max="10" pattern="^[0-9-+s()\\.]*$" id={formBuilderInputs.inputId} required=

                                                                                                    {formBuilderInputs.Required} />
                                                                             {(formBuilderInputs.infoIcon == "yes")&& <div className="form-element--info__icon" tabIndex="0" role="button" onClick={this.closeButton} onFocus={this.openTooltipOnFocus} onBlur={this.closeTooltipOnBlur} aria-label={formBuilderInputs.infoText.replace(/<[^>]*>?/gm, '')} data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"></div>}

                                                                                            </div>
                                                                                            <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                        </div>
                                                                                        </FormGroup>
                                                                                    );
                                                                                case "appointmentDate":
                                                                                    return (
                                                                                        <FormGroup key={formBuilderInputs.inputId} className="row">
                                                                                        <div className="col-sm-4">
                                                                                            <Label>{formBuilderInputs.label} {formBuilderInputs.Required && <span className="mandatory">*</span>}</Label>
                                                                                            </div>
                                                                                            <div className="col-sm-8">
                                                                                                <Input autoComplete="off" name={formBuilderInputs.inputId} aria-label={formBuilderInputs.label} id={formBuilderInputs.inputId} type="text" className="text-input form-date-picker js-date-picker" placeholder="DD/MM/YYYY" data-parsley-installationdate data-parsley-installationdate-message="Please select a valid date" data-parsley-required-message="Please select a preferred date" required=

                                                                                                {formBuilderInputs.Required} />

                                                                                            <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                            </div>
                                                                                        </FormGroup>

                                                                                    )
                                                                                case "date":
                                                                                    return (
                                                                                        <FormGroup key={formBuilderInputs.inputId} className="row">
                                                                                        <div className="col-sm-4">
                                                                                            <Label>{formBuilderInputs.label} {formBuilderInputs.Required && <span className="mandatory">*</span>}</Label>
                                                                                            </div>
                                                                                            <div className="col-sm-8"><Input aria-label={formBuilderInputs.label} autoComplete="off" name={formBuilderInputs.inputId} id={formBuilderInputs.inputId} type="text" className="text-input form-date-picker js-date-picker-no-restriction" placeholder="DD/MM/YYYY" data-parsley-installationdate data-parsley-installationdate-message="Please select a valid date" data-parsley-required-message="Please select a preferred date" required=

                                                                                                {formBuilderInputs.Required} />

                                                                                            <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                            </div>
                                                                                            </FormGroup>

                                                                                    )
                                                                                default:
                                                                                    return (
                                                                                        <FormGroup key={formBuilderInputs.inputId} className="row">
                                                                                        <div className="col-sm-4">
                                                                                            <Label>{formBuilderInputs.label} {formBuilderInputs.Required && <span className="mandatory">*</span>}</Label>
                                                                                           </div>
                                                                                           <div className="col-sm-8 form-element--info">
                                                                                            {/* <Input name={formBuilderInputs.inputId} autoComplete="on" aria-label={formBuilderInputs.label} type={FormBuilderInputFields.inputType}  placeholder={formBuilderInputs.placeholder} id={formBuilderInputs.inputId} pattern={formBuilderInputs.pattern} required=

                                                                                            {formBuilderInputs.Required} multiple={FormBuilderInputFields.inputType == 'file' ? true : false} />
                                                                                            {(formBuilderInputs.infoIcon == "yes")&&<div> <div className="form-element--info__icon" tabIndex="0" role="button" onClick={this.closeButton}  data-tooltip-body={formBuilderInputs.infoText+ (formBuilderInputs.infoImage !=""?"<br/><img style='width:160px;height:120px'  src='/opencms/export/sites/support"+formBuilderInputs.infoImage+"'>":"")} data-tooltip-type="generic" data-tooltip-position="top-right" data-tooltip="true"> </div></div> 
                                                                                            }
                                                                                            <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                            {FormBuilderInputFields.inputType == 'file' && <div className={formBuilderInputs.inputId} id={formBuilderInputs.inputId + '_file'} style={{ display: 'none', marginTop: '0.25rem', fontSize: '80%', color: '#e40046' }}>Please upload a max of 5 documents. </div>} 
                                                                                             */}
                                                                                            
                                                                                            {FormBuilderInputFields.inputType === "file" ? (
                                                                                                <div className="custom-file-upload-wrapper">                                                                                                    
                                                                                                    <input
                                                                                                        id={formBuilderInputs.inputId}
                                                                                                        name={formBuilderInputs.inputId}
                                                                                                        type="file"
                                                                                                        multiple={FormBuilderInputFields.inputType == 'file' ? true : false} 
                                                                                                        required={formBuilderInputs.Required}
                                                                                                        style={{ display: "none" }}
                                                                                                        onChange={(e) => {
                                                                                                            const files = Array.from(e.target.files);
                                                                                                            const el = document.getElementById(
                                                                                                                formBuilderInputs.inputId + "_fileNames"
                                                                                                            );
                                                                                                            
                                                                                                            // if (files.length > 0) {
                                                                                                            //     el.classList.remove("no-file");
                                                                                                            //     el.innerHTML = files
                                                                                                            //     .map(f => `<div>${f.name}</div>`)
                                                                                                            //     .join("");
                                                                                                            // } else {
                                                                                                            //     el.classList.add("no-file");
                                                                                                            //     el.innerHTML = "No file chosen";
                                                                                                            // }  
                                                                                                            
                                                                                                            if (files.length === 0) {
                                                                                                                el.classList.add("no-file");
                                                                                                                el.innerText = "No file chosen";
                                                                                                            } else if (files.length === 1) {
                                                                                                                el.classList.remove("no-file");
                                                                                                                el.innerText = files[0].name;
                                                                                                            } else {
                                                                                                                el.classList.remove("no-file");
                                                                                                                el.innerText = `${files.length} files`;
                                                                                                            }

                                                                                                        }}
                                                                                                    />
                                                                                                   
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="custom-file-btn btn-outline-primary"
                                                                                                        onClick={() =>
                                                                                                            document
                                                                                                                .getElementById(formBuilderInputs.inputId)
                                                                                                                .click()
                                                                                                        }
                                                                                                    >                                                                                                                                                                                                    
                                                                                                        <span className="upload-text">Upload files</span>
                                                                                                        <span className="upload-icon-wrapper" aria-hidden="true">                                                                                                            
                                                                                                            <span className="upload-icon-img upload-icon-default"></span>
                                                                                                            <span className="upload-icon-img upload-icon-hover"></span>
                                                                                                        </span>
                                                                                                    </button>
                                                                                                    
                                                                                                    {/* <div
                                                                                                        id={formBuilderInputs.inputId + "_fileNames"}
                                                                                                        className="file-names-list"
                                                                                                    >No file chosen</div> */}
                                                                                                    <span
                                                                                                        id={formBuilderInputs.inputId + "_fileNames"}
                                                                                                        className="file-names-list"
                                                                                                    >No file chosen</span>
                                                                                                    <FormFeedback>{formBuilderInputs.errorMsg}</FormFeedback>
                                                                                                </div>
                                                                                            ) : (
                                                                                                <Input
                                                                                                    name={formBuilderInputs.inputId}
                                                                                                    autoComplete="on"
                                                                                                    aria-label={formBuilderInputs.label}
                                                                                                    type={FormBuilderInputFields.inputType}
                                                                                                    placeholder={formBuilderInputs.placeholder}
                                                                                                    id={formBuilderInputs.inputId}
                                                                                                    pattern={formBuilderInputs.pattern}
                                                                                                    required={formBuilderInputs.Required}
                                                                                                />
                                                                                            )}

                                                                                            </div>
                                                                                        </FormGroup>
                                                                                    );
                                                                            }





                                                                        })
                                                                        }
                                                                    </React.Fragment>

                                                                );

                                                            })
                                                            }
                                                            {formBuilderSectionoptions.ParagraphSections != undefined && formBuilderSectionoptions.ParagraphSections.map((ParagraphSection, index) => {
                                                                return (
                                                                    <p key={index} dangerouslySetInnerHTML={this.renderContent(ParagraphSection.paragraph)}></p>

                                                                );
                                                            })}
                                                        </React.Fragment>
                                                    );
                                                })
                                            }
                                        </fieldset>
                                    );
                                })
                                }





                            </div>
                            <div className="d-flex justify-content-center">
                                <EirRecaptcha />
                            </div>

                            <div className="mt-4 d-flex justify-content-center" >
                            <button type="submit" name="Submit" value="Submit" aria-label="Submit form" className="btn btn-primary" onClick={this.handleSubmit} style={{ backgroundColor: this.state.proxyprops.sectionTitleColor,borderColor:this.state.proxyprops.sectionTitleColor}}>Submit</button>
                                {/* <EirButton 
                                    type="button"
                                    text="Submit"
                                    name="Submit"
                                    value="Submit"
                                    onClick={this.handleSubmit}
                                /> */}
                            </div>
                        </Form>
                    )
                    }
                    {(this.state.response != null && this.state.response.result.status == 'success') && (
                        <div className="form-success align-items-center" dangerouslySetInnerHTML={this.renderContent(this.state.proxyprops.successMsg)}></div>
                    )}

                    {(this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false)) && (
                        <div className="form-error align-items-center">{this.state.errMessage}</div>
                    )}
                </div>
            </div>



        )
    }
}

export default EirOnlineFormBuilder
